import {
  gql, useMutation 
} from "@apollo/client";

export const ADD_LOG = gql`
    mutation addJsLog(
        $type: String!
        $message: String!
        $time: String!
        $remark1: String!
    ) {
        addJsLog(
            input: {
                type: $type
                message: $message
                time: $time
                remark1: $remark1
            }
        ) {
            code
            message
            content
        }
    }
`;

export const useAddJslog = () => {

  const [addLog, {
    error: addLogError, loading: addLogLoading 
  }] =
        useMutation(ADD_LOG)

  return {
    addLog,
    addLogError,
    addLogLoading
  }
}
